<button
  class="button-primary-label"
  nz-button
  nzBlock
  nzType="primary"
  (click)="onClickButton($event)"
  [style.width]="width"
  [style.height]="height"
  [disabled]="disabled"
>
  <h3 class="h3"><ng-content></ng-content></h3>
</button>

